// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".welcome-modal__image{width:100%;height:100%;object-fit:cover}", "",{"version":3,"sources":["webpack://./src/Home/WelcomeModal/WelcomeModal.scss"],"names":[],"mappings":"AACE,sBACE,UAAA,CACA,WAAA,CACA,gBAAA","sourcesContent":[".welcome-modal {\n  &__image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
